var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(['myskoolhappinessfoundation'].includes(_vm.reportDomain))?_c('HappinessClasses'):_c('DepartmentAndClasses')],1)}
var staticRenderFns = []

export { render, staticRenderFns }